module.exports = __webpack_public_path__ + "img/feature-card3.187fde7e.png";